import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

export const SaveConvert = async (obj) => {
  const accesstoken = getToken();

  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ServiceRequest/convertToEntity`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success("Converted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};

